import './careers.css';
import React from 'react';

const GrowthText = () => {
  return (
    <p className="text">
      We partner with ridesharing platforms and OEMs across the globe to
      ensure the success of our drivesharing platform. We leverage our
      proprietary technology to launch and scale our operations in all
      major cities across the globe.
    </p>
  );
};

export default GrowthText;



// WEBPACK FOOTER //
// ./src/components/Careers/GrowthText.js